// The one dialer's context (CU-869fmbgfj), kept in its own module so Call
// buttons can reach the widget without importing it. TwilioVoiceProvider (the
// existing outbound widget, mounted in the dashboard layout) provides it.
import { createContext, useContext } from 'react';

export const DialerContext = createContext(null);

// null outside the dashboard layout: Call buttons then dial directly.
export const useDialer = () => useContext(DialerContext);
